import { RadioGroupItem } from '@/components/ui/radio-group';

export interface WishlistRadioRowProps {
  id: string;
  value: string;
  label: string;
  /** When set, this row is already selected — tapping it again deselects instead of no-op. */
  onDeselect?: () => void;
}

/** Row inside the Wishlist radio list: radio + list name. */
export function WishlistRadioRow({ id, value, label, onDeselect }: WishlistRadioRowProps) {
  return (
    <label
      htmlFor={id}
      onClick={
        onDeselect
          ? event => {
              event.preventDefault();
              onDeselect();
            }
          : undefined
      }
      className="border-jncquoi-neutral-900 flex w-full cursor-pointer items-center border-b-[0.5px] py-2.5"
    >
      <div className="flex size-11 shrink-0 items-center justify-center">
        <RadioGroupItem id={id} value={value} />
      </div>
      <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 flex-1 text-[12px] leading-none font-normal tracking-[0.5px] uppercase">
        {label}
      </span>
    </label>
  );
}
